// extracted by mini-css-extract-plugin
module.exports = {"tabs":"tabs_tabs__ZGwNe","item":"tabs_item__t1gkU","active":"tabs_active__GJA9B","itemBeforeShow":"tabs_itemBeforeShow__jEIDz"};